var OptionValue = /** @class */ (function () {
    function OptionValue(obj, id) {
        if (id) {
            this.id = id;
        }
        this.value = obj.value;
        this.option_type_id = obj.option_type_id;
    }
    Object.defineProperty(OptionValue.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OptionValue.prototype, "Value", {
        get: function () {
            return this.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OptionValue.prototype, "OptionTypeId", {
        get: function () {
            return this.option_type_id;
        },
        enumerable: false,
        configurable: true
    });
    return OptionValue;
}());
export { OptionValue };
export function createOptionValue(obj, id) {
    return new OptionValue(obj, id);
}
export function createOptionValues(rawValues) {
    var values = [];
    var rawValuesData = rawValues.data;
    for (var _i = 0, rawValuesData_1 = rawValuesData; _i < rawValuesData_1.length; _i++) {
        var rawValue = rawValuesData_1[_i];
        var value = createOptionValue(rawValue.attributes, rawValue.id);
        values.push(value);
    }
    return values;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/optionType/optionValue.ts
// module id = 121
// module chunks = 0